import { Component, OnInit, Input, OnChanges } from "@angular/core";
import { find, isEqual } from "lodash";

@Component({
  selector: "view-criteria",
  templateUrl: "./view-criteria.component.html",
  styleUrls: ["./view-criteria.component.scss"],
})
export class ViewCriteriaComponent implements OnInit, OnChanges {
  @Input() sortColumns;
  @Input() filterColumns;
  @Input() column;

  sortCol;
  filterCol;

  constructor() {}

  ngOnInit() {}

  ngOnChanges(change) {
    if (
      change.sortColumns &&
      !isEqual(
        change.sortColumns.currentValue,
        change.sortColumns.previousValue
      )
    ) {
      this.sortCol = find(this.sortColumns, ["student_kpi_id", this.column.id]);
    }
    if (
      change.filterColumns &&
      !isEqual(
        change.filterColumns.currentValue,
        change.filterColumns.previousValue
      )
    ) {
      this.filterCol = find(this.filterColumns, [
        "student_kpi_id",
        this.column.id,
      ]);
    }
  }
}
